const currentYear = new Date().getFullYear().toString()
export const COPYRIGHT_TEXT = `Copyright © ${currentYear} Audius`
